let interval = null;

export const timer = ($timer, countDownDate, elementClass, valueClass, sufixClass) => {
    clearInterval(interval);

    const updateCounter = (date) => {
        let days = Math.floor(date / (1000 * 60 * 60 * 24));
        days = days < 10 ? "0" + days : days;
        let hours = Math.floor((date % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        hours = hours < 10 ? "0" + hours : hours;
        let minutes = Math.floor((date % (1000 * 60 * 60)) / (1000 * 60));
        minutes = minutes < 10 ? "0" + minutes : minutes;
        let seconds = Math.floor((date % (1000 * 60)) / 1000);
        seconds = seconds < 10 ? "0" + seconds : seconds;

        $timer.innerHTML = `<th class="${elementClass}"><span class="${valueClass}">` + days + `</span><span class="${sufixClass}">dni</span></th>` +
            `<th class="${elementClass}"><span class="${valueClass}">` + hours + `</span><span class="${sufixClass}">godz.</span></th>` +
            `<th class="${elementClass}"><span class="${valueClass}">` + minutes + `</span><span class="${sufixClass}">min.</span></th>` +
            `<th class="${elementClass}"><span class="${valueClass}">` + seconds + `</span><span class="${sufixClass}">sek.</span></th>`;
    };

    const getDistance = () => {
        const now = new Date().getTime();
        let distance = countDownDate - now;
        distance = distance > 0 ? distance : 0;

        return distance;
    }

    const distance = getDistance();
    updateCounter(distance);

    interval = setInterval(() => {
        const distance = getDistance();
        updateCounter(distance);

        if (distance === 0) {
            clearInterval(interval);
        }
    }, 1000);
};

